import { defineAsyncComponent } from "vue";

export default [
  {
    name: "EditorCover",
    component: defineAsyncComponent(
      () => import("@modules/editor/components/lesson/LessonEditorCover.vue"),
    ),
    path: "",
    props: true,
  },
  {
    name: "EditorSectionCover",
    component: defineAsyncComponent(
      () => import("@modules/editor/components/lesson/LessonEditorSectionCover.vue"),
    ),
    path: "section/:sectionId",
    props: true,
  },
  {
    name: "EditorActivityPage",
    component: defineAsyncComponent(
      () => import("@modules/editor/components/lesson/LessonEditorActivity.vue"),
    ),
    // TODO: SLS-11043 (DONE), to enable :sectionId
    path: "section/:sectionId/activity/:pageId",
    props: true,
  },
  {
    path: "not-found",
    name: "EditorNotFoundPage",
    component: defineAsyncComponent(
      () => import("@modules/editor/components/lesson/LessonEditorNotFoundPage.vue"),
    ),
  },
  {
    path: "unpublished",
    name: "EditorUnpublishedPage",
    component: defineAsyncComponent(
      () => import("@modules/attempt/components/LessonUnpublishedPage.vue"),
    ),
  },
  {
    path: "module-plan",
    name: "EditorModulePlan",
    component: defineAsyncComponent(
      () => import("@modules/teacher-view-module-plan/CoursePlanEditor.vue"),
    ),
    props: true,
  },
  {
    path: "module-plan/reorder",
    name: "EditorModulePlanReorder",
    component: defineAsyncComponent(
      () => import("@modules/teacher-view-module-plan/CoursePlanReorder.vue"),
    ),
    props: true,
  },
  {
    path: "module-plan/learning-assistant-settings",
    name: "LearningAssistantSettings",
    component: defineAsyncComponent(
      () => import("@pages/learning-assistant-settings/LearningAssistantSettings.vue"),
    ),
  },
];
